// src/components/Footer.jsx

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#141e30] text-white px-6 py-10 mt-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        
        {/* Contact Section */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Contact Us</h2>
          <p className="mb-2">📧 <a href="mailto:enquiries@isnartech.com" className="hover:underline text-indigo-400">enquiries@isnartech.com</a></p>
          <p className="mb-2">📞 +91-9891940289, +91-7704836280</p>
          <p>🏢 Tower D, Sector-102, Gurgaon, India</p>
        </div>

        {/* Quick Links */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Quick Links</h2>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="hover:text-indigo-400 transition">Home</Link>
            </li>
            <li>
              <Link to="/features" className="hover:text-indigo-400 transition">Features</Link>
            </li>
            <li>
              <Link to="/registerSchool" className="hover:text-indigo-400 transition">Register Your School</Link>
            </li>
          </ul>
        </div>

        {/* Legal Section */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Legal</h2>
          <ul className="space-y-2">
            <li>
              <Link to="/privacy-policy" className="hover:text-indigo-400 transition">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="hover:text-indigo-400 transition">Terms & Conditions</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Isnartech Pvt. Ltd. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
